module.exports = __webpack_public_path__ + "img/9-1.615d83e2.png";